/**
 * Maps a route to the tool label put on a Service Desk ticket. The old
 * Confluence help client and Jira report code were removed when the help panel
 * moved to the in-house Service Desk.
 */

/** Route to the tool name the report form should preselect. */
export function toolLabelForPath(pathname: string): string | undefined {
  const p = pathname.toLowerCase();
  if (p === '/' || p === '') return 'Home';
  if (p.startsWith('/today')) return 'Today';
  if (p.startsWith('/inventory')) return 'Inventory';
  if (p.startsWith('/pulse')) return 'Pulse';
  if (p.startsWith('/sampling')) return 'Sampling';
  if (p.startsWith('/performance')) return 'Performance';
  if (p.startsWith('/promotions')) return 'Promotions';
  if (p.startsWith('/loyalty')) return 'Loyalty';
  if (p.startsWith('/recognition')) return 'Recognition';
  if (p.startsWith('/resources')) return 'Resources';
  if (p.startsWith('/my-store')) return 'My Store';
  if (p.startsWith('/directory')) return 'Directory';
  return undefined;
}
